var map = {
	"./Contact": [
		9407,
		407
	],
	"./Contact.tsx": [
		9407,
		407
	],
	"./Home": [
		1968,
		968
	],
	"./Home.tsx": [
		1968,
		968
	],
	"./Projects": [
		746,
		746
	],
	"./Projects.tsx": [
		746,
		746
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;